export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/9f6af27b89b4d7c0a5845f3d6f9de963.jpg"
          alt="Commercial buildout and residential renovation by Butler Frelix Construction"
          className="w-full h-full object-cover object-top"
        />
        {/* Dark navy gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-blue-950/90 via-blue-900/75 to-blue-900/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-16 flex flex-col lg:flex-row items-center lg:items-end justify-between gap-12">
        {/* Left Text */}
        <div className="w-full lg:max-w-3xl">
          <h1
            className="text-5xl md:text-6xl lg:text-8xl font-black text-white leading-none tracking-tight mb-6"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            WHERE EVERY
            <br />
            <span className="text-blue-400">BUILD BECOMES</span>
            <br />
            A LEGACY
          </h1>
          <p className="text-white/75 text-xl md:text-2xl mt-24 mb-10 max-w-2xl leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
            Butler Frelix Construction LLC brings expert craftsmanship, honest pricing, and fast turnaround to homes and businesses across Chicago.
          </p>
          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => handleScroll('#contact')}
              className="bg-red-700 hover:bg-red-800 text-white font-bold px-10 py-5 rounded-md text-lg transition-colors cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Start Your Solution
            </button>
            <button
              onClick={() => handleScroll('#services')}
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 font-bold px-10 py-5 rounded-md text-lg transition-colors cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              View Our Services
            </button>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="flex lg:flex-col gap-4 lg:gap-3 flex-row flex-wrap justify-center">
          {[
            { value: '11+', label: 'Years Experience' },
            { value: '500+', label: 'Projects Completed' },
            { value: '100%', label: 'Licensed & Insured' },
          ].map((stat) => (
            <div
              key={stat.label}
              className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl px-6 py-4 text-center min-w-[120px]"
            >
              <div className="text-4xl font-black text-blue-400" style={{ fontFamily: "'Oswald', sans-serif" }}>
                {stat.value}
              </div>
              <div className="text-white text-xs mt-1 whitespace-nowrap" style={{ fontFamily: "'Inter', sans-serif" }}>
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 animate-bounce">
        <div className="text-white/50 text-xs tracking-widest" style={{ fontFamily: "'Inter', sans-serif" }}>SCROLL</div>
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/50 text-lg" />
        </div>
      </div>
    </section>
  );
}
